import React, { useState } from "react";
import LoginPage from "./Login2";
import LocationSearchPage from "./LocationSearch";
import BusinessDetailsPage from "./BusinessDetails";

/*
  Simple state-based flow controller for the onboarding sequence:

    Login
      ├─ "Login" button      → LocationSearch (find your business)
      └─ "Register" link     → BusinessDetails (fill in your business)

    LocationSearch
      └─ selecting a result  → BusinessDetails (prefilled next step)

  If this app already uses a router (react-router, etc.), swap the
  setView() calls below for navigate("/location"), navigate("/business"),
  etc. — everything else (the three page components) stays the same.
*/
export default function AuthFlow() {
  const [view, setView] = useState("login"); // "login" | "location" | "business"
  const [selectedBusiness, setSelectedBusiness] = useState(null);

  if (view === "location") {
    return (
      <LocationSearchPage
        onSelectBusiness={(business) => {
          setSelectedBusiness(business);
          setView("business");
        }}
      />
    );
  }

  if (view === "business") {
    return (
      <BusinessDetailsPage
        prefill={selectedBusiness}
        onSave={() => {
          // business details saved — send them wherever "done" means
          // (dashboard, a confirmation screen, etc.)
        }}
      />
    );
  }

  return (
    <LoginPage
      onLogin={() => setView("location")}
      onGoRegister={() => setView("business")}
    />
  );
}